let grid_taks_resize = function() {
    let t = this;
    window.addEventListener("resize", function (e) {
        let divisor = t.grip_taks_divisor(window.innerWidth);
        t.grid_taks_generator(divisor);
    });
};
export default grid_taks_resize;
